import React, { useContext, useEffect, useState } from 'react'
import { AiFillHome } from "@react-icons/all-files/ai/AiFillHome";
import { BsCalendar } from "@react-icons/all-files/bs/BsCalendar";


import { MdFamilyRestroom, MdTipsAndUpdates, MdArrowRightAlt, MdOutlineKeyboardArrowRight, MdCalendarMonth, MdNotificationsNone } from 'react-icons/md';
import { FaPeopleGroup } from 'react-icons/fa6';
import { IoDocumentTextOutline, IoIosDocument, IoMdArrowDropdown } from 'react-icons/io';
import { CgProfile, CgLogOut, CgHashtag } from 'react-icons/cg';
import { SiHandshake } from 'react-icons/si';
import { AiOutlineSearch } from 'react-icons/ai'
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io'
import { BsFillPersonFill, BsClock } from 'react-icons/bs'
import Renderif from '../../components/renderif';
import { useNavigate } from 'react-router-dom';
import SideMenu from '../../components/sidemenu';
import AgendarCita from './agendar_client';
import Quiz from '../../components/quiz';
import Calendar from 'react-calendar';
import BVCalendar from '../../components/calendar';
import Slider from '../../components/slider';
import { gray10, gray20, gray30, gray40, gray70, gray100, primary } from '../../utils/colors';
import DropDown, { DropDownOption } from '../../components/dropdown';
import { AuthContext } from '../../context/auth_context';
import AlertNotification from '../../components/alert-notification';
import { Service } from '../../services/api';
import TipCard from '../../components/tipcard';
import SelectProfile from './select_profile_client';
import { FaRegCircle } from 'react-icons/fa';
import { GoGear } from 'react-icons/go';
// import 'react-calendar/dist/Calendar.css';



export default function HomeClient() {
    const navigate = useNavigate();
    const { user, logout } = useContext(AuthContext)
    console.log(user);


    const [state, setState] = useState({
        tab: 0,
        plan_tab: 0,
        show_agendar_cita: false,
        show_select_profile: false,
        show_onboarding: user.onboarding === "" || user.onboarding === null ? true : false,
        tips: [],
        appoiment: [],
        notifications_menu: false,
        agreements_menu: false,
        profile_menu: false

    })



    useEffect(() => {

        const init = async () => {
            // let tags = await Service('GET', `Tag?pageNumber=1&pageSize=999`);
            let tips = await Service('GET', `Tip?pageNumber=1&pageSize=8`);

            let citas = await Service('GET', 'Appointment?pageNumber=1&pageSize=999');
            // console.log(citas.data.data)
            let today = new Date();
            let next_citas = citas.data.data.filter((cita) => new Date(cita[0].dateOfEvent) > today).sort((citaA, citaB) => Number(new Date(citaA.dateOfEvent)) - Number(new Date(citaB.dateOfEvent)))
            next_citas.sort((a, b) => new Date(a[0].dateOfEvent).getTime() - new Date(b[0].dateOfEvent).getTime());
            if (next_citas.length > 0) {
                setState({ ...state, tips: tips.data.data, appoiment: [...next_citas[0]] })
            }
            else {
                setState({ ...state, tips: tips.data.data })
            }

            // console.log(state.appoiment)
            // let onboarding = localStorage.getItem('onboarding');

            // if(onboarding === null){
            //     console.log(false)
            // }else{
            //     console.log(true)
            // }
            // setState({...state, show_onboarding:onboarding === null ? true : false})
        };
        init();
        return () => { }
    }, [])

    const arr = [1, 1, 1, 1, 1, 1, 1]


    return (
        <>
            {/* <AlertNotification></AlertNotification> */}



            <Renderif isTrue={state.show_agendar_cita}>
                <AgendarCita onSchedule={(cita) => { }} onCancel={() => {
                    setState({ ...state, show_agendar_cita: false })
                }}></AgendarCita>
            </Renderif>

            <Renderif isTrue={state.show_onboarding}>
                <Quiz onClose={() => {
                    setState({ ...state, show_onboarding: false })
                }}></Quiz>
            </Renderif>

            <Renderif isTrue={state.show_select_profile}>
                <SelectProfile onCancel={() => {
                    setState({ ...state, show_select_profile: false })
                }}></SelectProfile>
            </Renderif>

            <div className='container-fluid d-flex h-100 bacground-gray'>





                <SideMenu></SideMenu>



                <div className='col pb-5 hide-scroll overflow-auto'>

                    <div className='row'>

                        <div className='d-flex flex-lg-row p-2 p-sm-3 bg-white border-b'>



                            {/* FOTO PERFIL Y NOMBRE DEL USUARIO */}
                            {/* <div className='d-flex align-items-center'>

                        <div className='avatar avatar--xl d-none d-xl-block cursor-pointer' onClick={()=>{
                            setState({...state, show_select_profile:true})
                        }}></div>
                        <div className='avatar avatar--mid d-block d-xl-none cursor-pointer' onClick={()=>{
                            setState({...state, show_select_profile:true})
                        }} ></div>

                        <div className='bold f-28 line-0 px-2 d-none d-xl-block'>¡Hola!, {user?.firstName} {user?.lastName}</div>
                        <div className='bold f-18 line-0 px-2 d-block d-xl-none'>¡Hola!, {user?.firstName} {user?.lastName}</div>

                    </div> */}
                            <div className='d-flex align-items-center'>
                                <div className='input--light-curve'>
                                    <div className='bv-icon bv-icon--mid'><AiOutlineSearch size={30}></AiOutlineSearch></div>
                                    <input placeholder='Busca Tips, Documentos, etc.'></input>
                                </div>
                            </div>
                            <div className='col'></div>

                            <div className='d-flex flex-column flex-md-row align-items-md-center justify-content-end'>

                                <div className='d-flex py-1 py-sm-2 order-0 order-md-1'>
                                    <div className='pe-2 cita-button flex-center'>
                                        <div className='bv-cta-curve bv-cta--primary-black bv-icon bv-icon--mid' onClick={() => {
                                            // setState({ ...state, show_agendar_cita: true })
                                            navigate('/client/crear-cita')
                                        }}>
                                            <MdCalendarMonth size={20} className='me-2'></MdCalendarMonth>
                                            Agendar cita
                                        </div>
                                    </div>
                                    <div className='pe-2'>
                                        <div className='bv-cta bv-cta--outline bv-cta-circle' onClick={() => {
                                            if (state.notifications_menu) {
                                                setState({ ...state, notifications_menu: false })
                                            } else {
                                                setState({ ...state, notifications_menu: true })
                                            }

                                        }}><MdNotificationsNone size={24} color={gray40}></MdNotificationsNone>
                                            <Renderif isTrue={state.notifications_menu}>
                                                <div className='float-menu'>
                                                    <div className='h-menu flex-center-left separator-h-bottom p-2'>
                                                        Notificaciones
                                                    </div>
                                                    <div className='b-menu'>
                                                        <div className='card-notification d-flex separator-h-top'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                Por el momento no cuenta con notificaciones
                                                            </div>
                                                        </div>
                                                        {/* <div className='card-notification d-flex separator-h-top'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                El Dr. Raymundo marqueda ha subido tus recuerdos
                                                            </div>
                                                        </div>
                                                        <div className='card-notification d-flex separator-h-top'>
                                                            <div className=''>
                                                                <div className='avatar-profile'></div>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                El Dr. Raymundo marqueda ha subido tus recuerdos
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </Renderif>
                                        </div>
                                    </div>

                                    <div className='pe-2 me-4 agreements'>
                                        <div className='bv-cta bv-cta--outline bv-cta-circle' onClick={() => {
                                            if (state.agreements_menu) {
                                                setState({ ...state, agreements_menu: false })
                                            } else {
                                                setState({ ...state, agreements_menu: true })
                                            }

                                        }}><FaPeopleGroup size={24} color={gray40}></FaPeopleGroup>
                                            <Renderif isTrue={state.agreements_menu}>
                                                <div className='float-menu'>
                                                    <div className='h-menu flex-center-left separator-h-bottom p-2'>
                                                        Acuerdos pendientes
                                                    </div>
                                                    <div className='b-menu'>
                                                        <div className='card-notification d-flex separator-h-top'>
                                                            <div className='flex-center ms-2'>
                                                                <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                Por el momento no cuenta con acuerdos
                                                            </div>
                                                        </div>
                                                        {/* <div className='card-notification d-flex separator-h-top'>
                                                            <div className='flex-center ms-2'>
                                                                <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                Hacer ejercicio
                                                            </div>
                                                        </div>
                                                        <div className='card-notification d-flex separator-h-top'>
                                                            <div className='flex-center ms-2'>
                                                                <FaRegCircle size={13} color={primary}></FaRegCircle>
                                                            </div>
                                                            <div className='flex-center f-12 p-2'>
                                                                Leer
                                                            </div>
                                                        </div> */}
                                                    </div>
                                                </div>
                                            </Renderif>
                                        </div>
                                    </div>

                                    <div className='pe-2 px-md-2 flex-center separator-v-left cursor-pointer' onClick={() => {
                                        if (state.profile_menu) {
                                            setState({ ...state, profile_menu: false })
                                        } else {
                                            setState({ ...state, profile_menu: true })
                                        }

                                    }}>
                                        <div className='avatar-profile  ms-lg-3'></div>
                                        <div className=''>
                                            <IoIosArrowDown size={18} color={'#000000'}></IoIosArrowDown>

                                        </div>

                                    </div>
                                    <Renderif isTrue={state.profile_menu}>
                                        <div className='float-menu-profile'>
                                            <div className='b-menu'>
                                                <div className='card-notification flex-center-j-left m-2'>
                                                    <div className=''>
                                                        <div className='avatar-profile'></div>
                                                    </div>
                                                    <div className='p-2'>
                                                        <div className='bold f-14'>
                                                            {user?.firstName} {user?.lastName}
                                                        </div>
                                                        <div className='f-12 text-miperfil bold cursor-pointer' onClick={() => {
                                                            navigate('/client/profile')
                                                        }}>
                                                            Mi perfil
                                                            <IoIosArrowForward size={12} color={primary} className='ms-1'></IoIosArrowForward>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='b-menu'>
                                                <div className='card-notification d-flex separator-h-top cursor-pointer'>
                                                    <div className='flex-center ms-2'>
                                                        <GoGear size={15} color={gray40}></GoGear>
                                                    </div>
                                                    <div className='flex-center f-12 p-2'>
                                                        Configuración
                                                    </div>
                                                </div>
                                                <div className='card-notification d-flex separator-h-top cursor-pointer' onClick={() => {
                                                    logout();
                                                    navigate('/')
                                                }}>
                                                    <div className='flex-center ms-2'>
                                                        <CgLogOut size={15} color={gray40} />
                                                    </div>
                                                    <div className='flex-center f-12 p-2'>
                                                        Cerrar sesión
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Renderif>
                                </div>



                            </div>


                        </div>


                        {/* <div className='p-1'>
                            <Slider></Slider>
                        </div> */}


                    </div>

                    <div className='row mx-lg-5'>
                        <div className='col-12 col-md-6 col-lg-9 ps-2 pe-4 mt-3'>
                            <div className='bv-card p-4'>
                                <Slider></Slider>
                            </div>
                            <div className='d-sm-none'>

                                <div className='p-4 bv-card mt-4'>
                                    <Renderif isTrue={state.appoiment.length > 0}>
                                        <div>
                                            <div className='h4'>
                                                Tu próxima cita
                                            </div>
                                            <div className='d-flex my-4'>
                                                <div className='avatar-profile avatar--xl d-none d-xl-block'></div>
                                                <div className='avatar-profile avatar--mid d-block d-xl-none'></div>
                                                <div>
                                                    {console.log(state.appoiment)}
                                                    <div className='bold line-0 px-2 d-none d-xl-block'>Dr. {state.appoiment[0]?.specialist?.firstName} {state.appoiment[0]?.specialist?.lastName}</div>
                                                    <div className='bold line-0 px-2 d-block d-xl-none'>Dr. {state.appoiment[0]?.specialist?.firstName} {state.appoiment[0]?.specialist?.lastName}</div>
                                                    <div className='mx-2'>
                                                        Psicólogo
                                                    </div>
                                                    <div className='mx-2 my-2'>
                                                        <div className={`bv-pill cursor-pointer bv-pill--primary`} onClick={() => {
                                                            window.open(state.appoiment[0]?.sessionUrl, '_blank')
                                                        }}>
                                                            Videollamada
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className='bv-card'>
                                                <div className='mt-2'>
                                                    <MdCalendarMonth size={20} className='mx-3'></MdCalendarMonth>{state.appoiment[0]?.dateOfEvent.slice(0, 10)}
                                                </div>
                                                <div className='my-2'>
                                                    <BsClock size={20} className='mx-3'></BsClock>{state.appoiment[0]?.dateOfEvent.slice(11, 16)} horas
                                                </div>
                                            </div>
                                        </div>
                                    </Renderif>
                                    <Renderif isTrue={state.appoiment.length === 0}>
                                        <div>
                                            <div className='pe-2 cita-button flex-center'>
                                                <div className='bv-cta-curve bv-cta--primary-black bv-icon bv-icon--mid' onClick={() => {
                                                    navigate('/client/crear-cita')
                                                }}>
                                                    <MdCalendarMonth size={20} className='me-2'></MdCalendarMonth>
                                                    Agendar cita
                                                </div>
                                            </div>
                                        </div>
                                    </Renderif>

                                </div>
                            </div>
                            <div className='my-3 text-black bold h4 mt-4'>
                                Tips para tí
                            </div>
                            <div className='bv-card p-4'>

                                {/* <div className='d-flex'>

                                    <div className='d-flex align-items-center cursor-pointer pe-3' onClick={() => {
                                        setState({ ...state, tab: 0 })
                                    }}>
                                        <div className='bv-icon me-1'> <MdTipsAndUpdates size={30} color={gray30} /></div>
                                        <div className={`text-dark f-14 bold ${state.tab === 0 ? 'text-primary' : ''} text-decoration-underline`}>Tips</div>
                                    </div>

                                    <div className='d-flex align-items-center cursor-pointer'
                                        onClick={() => {
                                            setState({ ...state, tab: 1 })
                                        }}>
                                        <div className='bv-icon me-1'> <IoIosDocument size={30} color={gray30} /></div>
                                        <div className={`text-dark f-14 bold ${state.tab === 1 ? 'text-primary' : ''} text-decoration-underline`}>Documentos</div>
                                    </div>

                                    <div className='col'></div>
                                    <DropDown
                                        title=''
                                        open={false}
                                        defaultValue={5}
                                        _onChange={(evt) => {

                                        }}>
                                        <DropDownOption value={5} label="Todo">
                                            <div className='f-14 text-gray'>Todo</div>
                                        </DropDownOption>
                                        <DropDownOption value={10} label="Nuevo">
                                            <div className='f-14 text-gray'>Nuevo</div>
                                        </DropDownOption>



                                    </DropDown>

                                </div> */}


                                {/* TIPS */}
                                {/* <div className='d-flex flex-nowrap align-items-end'></div> */}
                                <Renderif isTrue={state.tab === 0}>

                                    <div className='flex-wrap align-items-end  d-none d-md-flex'>
                                        {state.tips.map((tip, i) => {

                                            if (tip.id === '9c1c02e2-1ac6-42da-b6a9-9aae4af8e89c') { return }

                                            return (
                                                <div key={i} className='w-25-50-100 px-1'>
                                                    <TipCard tip={tip} tag="¡Nuevo!" i={i} key={i}></TipCard>
                                                </div>

                                            )
                                        })}

                                    </div>

                                    <div className='overflow-auto hide-scroll no-wrap d-block d-md-none'>
                                        {state.tips.map((tip, i) => {
                                            if (tip.id === '9c1c02e2-1ac6-42da-b6a9-9aae4af8e89c') { return }
                                            return (

                                                <div key={i} className='px-1 line-card'>
                                                    <TipCard tip={tip} tag="¡Nuevo!" i={i} key={i}></TipCard>
                                                </div>

                                            )
                                        })}
                                    </div>
                                </Renderif>

                                {/* <Renderif isTrue={state.tab === 1}>

                                    <div className='p-3'>
                                        <div className=' text-gray'>Sin documentos.</div>
                                    </div>

                                </Renderif> */}


                                {/* ENF TIPS */}
                            </div>

                        </div>

                        <div className='col-12 col-md-6 col-lg-3 px-2 mt-3 mobile-d-none'>

                            <div className='p-4 bv-card'>
                                <Renderif isTrue={state.appoiment.length > 0}>
                                    <div>
                                        <div className='h4'>
                                            Tu próxima cita
                                        </div>
                                        <div className='d-flex my-4'>
                                            <div className='avatar-profile avatar--xl d-none d-xl-block'></div>
                                            <div className='avatar-profile avatar--mid d-block d-xl-none'></div>
                                            <div>
                                                {console.log(state.appoiment)}
                                                <div className='bold line-0 px-2 d-none d-xl-block'>Dr. {state.appoiment[0]?.specialist?.firstName} {state.appoiment[0]?.specialist?.lastName}</div>
                                                <div className='bold line-0 px-2 d-block d-xl-none'>Dr. {state.appoiment[0]?.specialist?.firstName} {state.appoiment[0]?.specialist?.lastName}</div>
                                                <div className='mx-2'>
                                                    Psicólogo
                                                </div>
                                                <div className='mx-2 my-2'>
                                                    <div className={`bv-pill cursor-pointer bv-pill--primary`} onClick={() => {
                                                        window.open(state.appoiment[0]?.sessionUrl, '_blank')
                                                    }}>
                                                        Videollamada
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className='bv-card'>
                                            <div className='mt-2'>
                                                <MdCalendarMonth size={20} className='mx-3'></MdCalendarMonth>{state.appoiment[0]?.dateOfEvent.slice(0, 10)}
                                            </div>
                                            <div className='my-2'>
                                                <BsClock size={20} className='mx-3'></BsClock>{state.appoiment[0]?.dateOfEvent.slice(11, 16)} horas
                                            </div>
                                        </div>
                                    </div>
                                </Renderif>
                                <Renderif isTrue={state.appoiment.length === 0}>
                                    <div>
                                        <div className='pe-2 cita-button flex-center'>
                                            <div className='bv-cta-curve bv-cta--primary-black bv-icon bv-icon--mid' onClick={() => {
                                                navigate('/client/crear-cita')
                                            }}>
                                                <MdCalendarMonth size={20} className='me-2'></MdCalendarMonth>
                                                Agendar cita
                                            </div>
                                        </div>
                                    </div>
                                </Renderif>

                            </div>


                        </div>

                    </div>

                </div>







            </div>
        </>
    )
}
